// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"a8275e07","221":"37cd6324","223":"1a35fa84","453":"6105374c","455":"4353c474","497":"7582e7a3","977":"a61de3f2"}[chunkId] + ".chunk.js";
};